// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as MarketingRouteImport } from './routes/_marketing'
import { Route as SaasRouteImport } from './routes/_saas'
import { Route as EmbedTestRouteImport } from './routes/embed-test'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthSignupRouteImport } from './routes/_auth/signup'
import { Route as AuthVerifyRouteImport } from './routes/_auth/verify'
import { Route as MarketingIndexRouteImport } from './routes/_marketing/index'
import { Route as MarketingAgenticCommerceRouteImport } from './routes/_marketing/agentic-commerce'
import { Route as MarketingAiAgentForEcommerceRouteImport } from './routes/_marketing/ai-agent-for-ecommerce'
import { Route as MarketingArabicChatbotForEcommerceRouteImport } from './routes/_marketing/arabic-chatbot-for-ecommerce'
import { Route as MarketingBestAiShoppingAssistantsRouteImport } from './routes/_marketing/best-ai-shopping-assistants'
import { Route as MarketingDemoRouteImport } from './routes/_marketing/demo'
import { Route as MarketingHowItWorksRouteImport } from './routes/_marketing/how-it-works'
import { Route as MarketingIntegrationsRouteImport } from './routes/_marketing/integrations'
import { Route as MarketingLebanonRouteImport } from './routes/_marketing/lebanon'
import { Route as MarketingQuickCommerceRouteImport } from './routes/_marketing/quick-commerce'
import { Route as MarketingSaudiArabiaRouteImport } from './routes/_marketing/saudi-arabia'
import { Route as MarketingSecurityRouteImport } from './routes/_marketing/security'
import { Route as MarketingShoppableRecipesRouteImport } from './routes/_marketing/shoppable-recipes'
import { Route as MarketingSupermarketsRouteImport } from './routes/_marketing/supermarkets'
import { Route as MarketingUaeRouteImport } from './routes/_marketing/uae'
import { Route as SaasAppRouteImport } from './routes/_saas/app'
import { Route as SaasNewOrganizationRouteImport } from './routes/_saas/new-organization'
import { Route as COrgSlugRouteImport } from './routes/c.$orgSlug'
import { Route as LegalSlugRouteImport } from './routes/legal.$slug'
import { Route as MarketingChannelsInAppRouteImport } from './routes/_marketing/channels/in-app'
import { Route as MarketingChannelsVoiceRouteImport } from './routes/_marketing/channels/voice'
import { Route as MarketingChannelsWhatsappRouteImport } from './routes/_marketing/channels/whatsapp'
import { Route as MarketingCompareIndexRouteImport } from './routes/_marketing/compare/index'
import { Route as MarketingCompareVendorRouteImport } from './routes/_marketing/compare/$vendor'
import { Route as MarketingSecurityPdplRouteImport } from './routes/_marketing/security_.pdpl'
import { Route as SaasAppAccountRouteImport } from './routes/_saas/app/_account'
import { Route as SaasOrganizationInvitationInvitationIdRouteImport } from './routes/_saas/organization-invitation/$invitationId'
import { Route as SaasAppAccountIndexRouteImport } from './routes/_saas/app/_account/index'
import { Route as SaasAppAccountPartnerRouteImport } from './routes/_saas/app/_account/partner'
import { Route as SaasAppAccountPlatformRouteImport } from './routes/_saas/app/_account/platform'
import { Route as SaasAppAccountSettingsRouteImport } from './routes/_saas/app/_account/settings'
import { Route as SaasAppOrgOrganizationSlugRouteImport } from './routes/_saas/app/_org/$organizationSlug'
import { Route as COrgSlugCheckoutCheckoutIdRouteImport } from './routes/c.$orgSlug_.checkout.$checkoutId'
import { Route as COrgSlugOrdersTokenRouteImport } from './routes/c.$orgSlug_.orders.$token'
import { Route as SaasAppAccountSettingsIndexRouteImport } from './routes/_saas/app/_account/settings/index'
import { Route as SaasAppAccountSettingsDangerZoneRouteImport } from './routes/_saas/app/_account/settings/danger-zone'
import { Route as SaasAppAccountSettingsGeneralRouteImport } from './routes/_saas/app/_account/settings/general'
import { Route as SaasAppAccountSettingsNotificationsRouteImport } from './routes/_saas/app/_account/settings/notifications'
import { Route as SaasAppAccountSettingsPrivacyRouteImport } from './routes/_saas/app/_account/settings/privacy'
import { Route as SaasAppAccountSettingsSecurityRouteImport } from './routes/_saas/app/_account/settings/security'
import { Route as SaasAppOrgOrganizationSlugIndexRouteImport } from './routes/_saas/app/_org/$organizationSlug/index'
import { Route as SaasAppOrgOrganizationSlugSplatRouteImport } from './routes/_saas/app/_org/$organizationSlug/$'
import { Route as SaasAppOrgOrganizationSlugAgentRouteImport } from './routes/_saas/app/_org/$organizationSlug/agent'
import { Route as SaasAppOrgOrganizationSlugBranchesRouteImport } from './routes/_saas/app/_org/$organizationSlug/branches'
import { Route as SaasAppOrgOrganizationSlugCatalogRouteImport } from './routes/_saas/app/_org/$organizationSlug/catalog'
import { Route as SaasAppOrgOrganizationSlugConversationsRouteImport } from './routes/_saas/app/_org/$organizationSlug/conversations'
import { Route as SaasAppOrgOrganizationSlugConversionsRouteImport } from './routes/_saas/app/_org/$organizationSlug/conversions'
import { Route as SaasAppOrgOrganizationSlugEvalsRouteImport } from './routes/_saas/app/_org/$organizationSlug/evals'
import { Route as SaasAppOrgOrganizationSlugInstallRouteImport } from './routes/_saas/app/_org/$organizationSlug/install'
import { Route as SaasAppOrgOrganizationSlugIntegrationsRouteImport } from './routes/_saas/app/_org/$organizationSlug/integrations'
import { Route as SaasAppOrgOrganizationSlugLogsRouteImport } from './routes/_saas/app/_org/$organizationSlug/logs'
import { Route as SaasAppOrgOrganizationSlugSearchRouteImport } from './routes/_saas/app/_org/$organizationSlug/search'
import { Route as SaasAppOrgOrganizationSlugSettingsRouteImport } from './routes/_saas/app/_org/$organizationSlug/settings'
import { Route as SaasAppOrgOrganizationSlugCallsIndexRouteImport } from './routes/_saas/app/_org/$organizationSlug/calls/index'
import { Route as SaasAppOrgOrganizationSlugCallsCallIdRouteImport } from './routes/_saas/app/_org/$organizationSlug/calls/$callId'
import { Route as SaasAppOrgOrganizationSlugChannelsIndexRouteImport } from './routes/_saas/app/_org/$organizationSlug/channels/index'
import { Route as SaasAppOrgOrganizationSlugChannelsTemplatesRouteImport } from './routes/_saas/app/_org/$organizationSlug/channels/templates'
import { Route as SaasAppOrgOrganizationSlugCustomersIndexRouteImport } from './routes/_saas/app/_org/$organizationSlug/customers/index'
import { Route as SaasAppOrgOrganizationSlugCustomersCustomerIdRouteImport } from './routes/_saas/app/_org/$organizationSlug/customers/$customerId'
import { Route as SaasAppOrgOrganizationSlugOrdersIndexRouteImport } from './routes/_saas/app/_org/$organizationSlug/orders/index'
import { Route as SaasAppOrgOrganizationSlugOrdersOrderIdRouteImport } from './routes/_saas/app/_org/$organizationSlug/orders/$orderId'
import { Route as SaasAppOrgOrganizationSlugOrdersSetupRouteImport } from './routes/_saas/app/_org/$organizationSlug/orders/setup'
import { Route as SaasAppOrgOrganizationSlugSettingsIndexRouteImport } from './routes/_saas/app/_org/$organizationSlug/settings/index'
import { Route as SaasAppOrgOrganizationSlugSettingsApiKeysRouteImport } from './routes/_saas/app/_org/$organizationSlug/settings/api-keys'
import { Route as SaasAppOrgOrganizationSlugSettingsAuditRouteImport } from './routes/_saas/app/_org/$organizationSlug/settings/audit'
import { Route as SaasAppOrgOrganizationSlugSettingsDangerZoneRouteImport } from './routes/_saas/app/_org/$organizationSlug/settings/danger-zone'
import { Route as SaasAppOrgOrganizationSlugSettingsDomainsRouteImport } from './routes/_saas/app/_org/$organizationSlug/settings/domains'
import { Route as SaasAppOrgOrganizationSlugSettingsGeneralRouteImport } from './routes/_saas/app/_org/$organizationSlug/settings/general'
import { Route as SaasAppOrgOrganizationSlugSettingsMembersRouteImport } from './routes/_saas/app/_org/$organizationSlug/settings/members'
import { Route as SaasAppOrgOrganizationSlugSettingsPrivacyDataRouteImport } from './routes/_saas/app/_org/$organizationSlug/settings/privacy-data'
import { Route as SaasAppOrgOrganizationSlugSettingsRolesRouteImport } from './routes/_saas/app/_org/$organizationSlug/settings/roles'
import { Route as SaasAppOrgOrganizationSlugSettingsUsageRouteImport } from './routes/_saas/app/_org/$organizationSlug/settings/usage'
import { Route as SaasAppOrgOrganizationSlugSourcesIndexRouteImport } from './routes/_saas/app/_org/$organizationSlug/sources/index'
import { Route as SaasAppOrgOrganizationSlugSourcesSourceIdRouteImport } from './routes/_saas/app/_org/$organizationSlug/sources/$sourceId'
import { Route as SaasAppOrgOrganizationSlugChannelsWhatsappConnectionIdRouteImport } from './routes/_saas/app/_org/$organizationSlug/channels/whatsapp.$connectionId'

const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const MarketingRoute = MarketingRouteImport.update({
            id: '/_marketing',getParentRoute: () => rootRouteImport
          })
const SaasRoute = SaasRouteImport.update({
            id: '/_saas',getParentRoute: () => rootRouteImport
          })
const EmbedTestRoute = EmbedTestRouteImport.update({
            id: '/embed-test',path: '/embed-test',getParentRoute: () => rootRouteImport
          })
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => AuthRoute
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => AuthRoute
          })
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => AuthRoute
          })
const AuthSignupRoute = AuthSignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => AuthRoute
          })
const AuthVerifyRoute = AuthVerifyRouteImport.update({
            id: '/verify',path: '/verify',getParentRoute: () => AuthRoute
          })
const MarketingIndexRoute = MarketingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MarketingRoute
          })
const MarketingAgenticCommerceRoute = MarketingAgenticCommerceRouteImport.update({
            id: '/agentic-commerce',path: '/agentic-commerce',getParentRoute: () => MarketingRoute
          })
const MarketingAiAgentForEcommerceRoute = MarketingAiAgentForEcommerceRouteImport.update({
            id: '/ai-agent-for-ecommerce',path: '/ai-agent-for-ecommerce',getParentRoute: () => MarketingRoute
          })
const MarketingArabicChatbotForEcommerceRoute = MarketingArabicChatbotForEcommerceRouteImport.update({
            id: '/arabic-chatbot-for-ecommerce',path: '/arabic-chatbot-for-ecommerce',getParentRoute: () => MarketingRoute
          })
const MarketingBestAiShoppingAssistantsRoute = MarketingBestAiShoppingAssistantsRouteImport.update({
            id: '/best-ai-shopping-assistants',path: '/best-ai-shopping-assistants',getParentRoute: () => MarketingRoute
          })
const MarketingDemoRoute = MarketingDemoRouteImport.update({
            id: '/demo',path: '/demo',getParentRoute: () => MarketingRoute
          })
const MarketingHowItWorksRoute = MarketingHowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => MarketingRoute
          })
const MarketingIntegrationsRoute = MarketingIntegrationsRouteImport.update({
            id: '/integrations',path: '/integrations',getParentRoute: () => MarketingRoute
          })
const MarketingLebanonRoute = MarketingLebanonRouteImport.update({
            id: '/lebanon',path: '/lebanon',getParentRoute: () => MarketingRoute
          })
const MarketingQuickCommerceRoute = MarketingQuickCommerceRouteImport.update({
            id: '/quick-commerce',path: '/quick-commerce',getParentRoute: () => MarketingRoute
          })
const MarketingSaudiArabiaRoute = MarketingSaudiArabiaRouteImport.update({
            id: '/saudi-arabia',path: '/saudi-arabia',getParentRoute: () => MarketingRoute
          })
const MarketingSecurityRoute = MarketingSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => MarketingRoute
          })
const MarketingShoppableRecipesRoute = MarketingShoppableRecipesRouteImport.update({
            id: '/shoppable-recipes',path: '/shoppable-recipes',getParentRoute: () => MarketingRoute
          })
const MarketingSupermarketsRoute = MarketingSupermarketsRouteImport.update({
            id: '/supermarkets',path: '/supermarkets',getParentRoute: () => MarketingRoute
          })
const MarketingUaeRoute = MarketingUaeRouteImport.update({
            id: '/uae',path: '/uae',getParentRoute: () => MarketingRoute
          })
const SaasAppRoute = SaasAppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => SaasRoute
          })
const SaasNewOrganizationRoute = SaasNewOrganizationRouteImport.update({
            id: '/new-organization',path: '/new-organization',getParentRoute: () => SaasRoute
          })
const COrgSlugRoute = COrgSlugRouteImport.update({
            id: '/c/$orgSlug',path: '/c/$orgSlug',getParentRoute: () => rootRouteImport
          })
const LegalSlugRoute = LegalSlugRouteImport.update({
            id: '/legal/$slug',path: '/legal/$slug',getParentRoute: () => rootRouteImport
          })
const MarketingChannelsInAppRoute = MarketingChannelsInAppRouteImport.update({
            id: '/channels/in-app',path: '/channels/in-app',getParentRoute: () => MarketingRoute
          })
const MarketingChannelsVoiceRoute = MarketingChannelsVoiceRouteImport.update({
            id: '/channels/voice',path: '/channels/voice',getParentRoute: () => MarketingRoute
          })
const MarketingChannelsWhatsappRoute = MarketingChannelsWhatsappRouteImport.update({
            id: '/channels/whatsapp',path: '/channels/whatsapp',getParentRoute: () => MarketingRoute
          })
const MarketingCompareIndexRoute = MarketingCompareIndexRouteImport.update({
            id: '/compare/',path: '/compare/',getParentRoute: () => MarketingRoute
          })
const MarketingCompareVendorRoute = MarketingCompareVendorRouteImport.update({
            id: '/compare/$vendor',path: '/compare/$vendor',getParentRoute: () => MarketingRoute
          })
const MarketingSecurityPdplRoute = MarketingSecurityPdplRouteImport.update({
            id: '/security_/pdpl',path: '/security/pdpl',getParentRoute: () => MarketingRoute
          })
const SaasAppAccountRoute = SaasAppAccountRouteImport.update({
            id: '/_account',getParentRoute: () => SaasAppRoute
          })
const SaasOrganizationInvitationInvitationIdRoute = SaasOrganizationInvitationInvitationIdRouteImport.update({
            id: '/organization-invitation/$invitationId',path: '/organization-invitation/$invitationId',getParentRoute: () => SaasRoute
          })
const SaasAppAccountIndexRoute = SaasAppAccountIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SaasAppAccountRoute
          })
const SaasAppAccountPartnerRoute = SaasAppAccountPartnerRouteImport.update({
            id: '/partner',path: '/partner',getParentRoute: () => SaasAppAccountRoute
          })
const SaasAppAccountPlatformRoute = SaasAppAccountPlatformRouteImport.update({
            id: '/platform',path: '/platform',getParentRoute: () => SaasAppAccountRoute
          })
const SaasAppAccountSettingsRoute = SaasAppAccountSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => SaasAppAccountRoute
          })
const SaasAppOrgOrganizationSlugRoute = SaasAppOrgOrganizationSlugRouteImport.update({
            id: '/_org/$organizationSlug',path: '/$organizationSlug',getParentRoute: () => SaasAppRoute
          })
const COrgSlugCheckoutCheckoutIdRoute = COrgSlugCheckoutCheckoutIdRouteImport.update({
            id: '/c/$orgSlug_/checkout/$checkoutId',path: '/c/$orgSlug/checkout/$checkoutId',getParentRoute: () => rootRouteImport
          })
const COrgSlugOrdersTokenRoute = COrgSlugOrdersTokenRouteImport.update({
            id: '/c/$orgSlug_/orders/$token',path: '/c/$orgSlug/orders/$token',getParentRoute: () => rootRouteImport
          })
const SaasAppAccountSettingsIndexRoute = SaasAppAccountSettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SaasAppAccountSettingsRoute
          })
const SaasAppAccountSettingsDangerZoneRoute = SaasAppAccountSettingsDangerZoneRouteImport.update({
            id: '/danger-zone',path: '/danger-zone',getParentRoute: () => SaasAppAccountSettingsRoute
          })
const SaasAppAccountSettingsGeneralRoute = SaasAppAccountSettingsGeneralRouteImport.update({
            id: '/general',path: '/general',getParentRoute: () => SaasAppAccountSettingsRoute
          })
const SaasAppAccountSettingsNotificationsRoute = SaasAppAccountSettingsNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => SaasAppAccountSettingsRoute
          })
const SaasAppAccountSettingsPrivacyRoute = SaasAppAccountSettingsPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => SaasAppAccountSettingsRoute
          })
const SaasAppAccountSettingsSecurityRoute = SaasAppAccountSettingsSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => SaasAppAccountSettingsRoute
          })
const SaasAppOrgOrganizationSlugIndexRoute = SaasAppOrgOrganizationSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugSplatRoute = SaasAppOrgOrganizationSlugSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugAgentRoute = SaasAppOrgOrganizationSlugAgentRouteImport.update({
            id: '/agent',path: '/agent',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugBranchesRoute = SaasAppOrgOrganizationSlugBranchesRouteImport.update({
            id: '/branches',path: '/branches',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugCatalogRoute = SaasAppOrgOrganizationSlugCatalogRouteImport.update({
            id: '/catalog',path: '/catalog',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugConversationsRoute = SaasAppOrgOrganizationSlugConversationsRouteImport.update({
            id: '/conversations',path: '/conversations',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugConversionsRoute = SaasAppOrgOrganizationSlugConversionsRouteImport.update({
            id: '/conversions',path: '/conversions',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugEvalsRoute = SaasAppOrgOrganizationSlugEvalsRouteImport.update({
            id: '/evals',path: '/evals',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugInstallRoute = SaasAppOrgOrganizationSlugInstallRouteImport.update({
            id: '/install',path: '/install',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugIntegrationsRoute = SaasAppOrgOrganizationSlugIntegrationsRouteImport.update({
            id: '/integrations',path: '/integrations',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugLogsRoute = SaasAppOrgOrganizationSlugLogsRouteImport.update({
            id: '/logs',path: '/logs',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugSearchRoute = SaasAppOrgOrganizationSlugSearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugSettingsRoute = SaasAppOrgOrganizationSlugSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugCallsIndexRoute = SaasAppOrgOrganizationSlugCallsIndexRouteImport.update({
            id: '/calls/',path: '/calls/',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugCallsCallIdRoute = SaasAppOrgOrganizationSlugCallsCallIdRouteImport.update({
            id: '/calls/$callId',path: '/calls/$callId',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugChannelsIndexRoute = SaasAppOrgOrganizationSlugChannelsIndexRouteImport.update({
            id: '/channels/',path: '/channels/',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugChannelsTemplatesRoute = SaasAppOrgOrganizationSlugChannelsTemplatesRouteImport.update({
            id: '/channels/templates',path: '/channels/templates',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugCustomersIndexRoute = SaasAppOrgOrganizationSlugCustomersIndexRouteImport.update({
            id: '/customers/',path: '/customers/',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugCustomersCustomerIdRoute = SaasAppOrgOrganizationSlugCustomersCustomerIdRouteImport.update({
            id: '/customers/$customerId',path: '/customers/$customerId',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugOrdersIndexRoute = SaasAppOrgOrganizationSlugOrdersIndexRouteImport.update({
            id: '/orders/',path: '/orders/',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugOrdersOrderIdRoute = SaasAppOrgOrganizationSlugOrdersOrderIdRouteImport.update({
            id: '/orders/$orderId',path: '/orders/$orderId',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugOrdersSetupRoute = SaasAppOrgOrganizationSlugOrdersSetupRouteImport.update({
            id: '/orders/setup',path: '/orders/setup',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugSettingsIndexRoute = SaasAppOrgOrganizationSlugSettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SaasAppOrgOrganizationSlugSettingsRoute
          })
const SaasAppOrgOrganizationSlugSettingsApiKeysRoute = SaasAppOrgOrganizationSlugSettingsApiKeysRouteImport.update({
            id: '/api-keys',path: '/api-keys',getParentRoute: () => SaasAppOrgOrganizationSlugSettingsRoute
          })
const SaasAppOrgOrganizationSlugSettingsAuditRoute = SaasAppOrgOrganizationSlugSettingsAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => SaasAppOrgOrganizationSlugSettingsRoute
          })
const SaasAppOrgOrganizationSlugSettingsDangerZoneRoute = SaasAppOrgOrganizationSlugSettingsDangerZoneRouteImport.update({
            id: '/danger-zone',path: '/danger-zone',getParentRoute: () => SaasAppOrgOrganizationSlugSettingsRoute
          })
const SaasAppOrgOrganizationSlugSettingsDomainsRoute = SaasAppOrgOrganizationSlugSettingsDomainsRouteImport.update({
            id: '/domains',path: '/domains',getParentRoute: () => SaasAppOrgOrganizationSlugSettingsRoute
          })
const SaasAppOrgOrganizationSlugSettingsGeneralRoute = SaasAppOrgOrganizationSlugSettingsGeneralRouteImport.update({
            id: '/general',path: '/general',getParentRoute: () => SaasAppOrgOrganizationSlugSettingsRoute
          })
const SaasAppOrgOrganizationSlugSettingsMembersRoute = SaasAppOrgOrganizationSlugSettingsMembersRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => SaasAppOrgOrganizationSlugSettingsRoute
          })
const SaasAppOrgOrganizationSlugSettingsPrivacyDataRoute = SaasAppOrgOrganizationSlugSettingsPrivacyDataRouteImport.update({
            id: '/privacy-data',path: '/privacy-data',getParentRoute: () => SaasAppOrgOrganizationSlugSettingsRoute
          })
const SaasAppOrgOrganizationSlugSettingsRolesRoute = SaasAppOrgOrganizationSlugSettingsRolesRouteImport.update({
            id: '/roles',path: '/roles',getParentRoute: () => SaasAppOrgOrganizationSlugSettingsRoute
          })
const SaasAppOrgOrganizationSlugSettingsUsageRoute = SaasAppOrgOrganizationSlugSettingsUsageRouteImport.update({
            id: '/usage',path: '/usage',getParentRoute: () => SaasAppOrgOrganizationSlugSettingsRoute
          })
const SaasAppOrgOrganizationSlugSourcesIndexRoute = SaasAppOrgOrganizationSlugSourcesIndexRouteImport.update({
            id: '/sources/',path: '/sources/',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugSourcesSourceIdRoute = SaasAppOrgOrganizationSlugSourcesSourceIdRouteImport.update({
            id: '/sources/$sourceId',path: '/sources/$sourceId',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })
const SaasAppOrgOrganizationSlugChannelsWhatsappConnectionIdRoute = SaasAppOrgOrganizationSlugChannelsWhatsappConnectionIdRouteImport.update({
            id: '/channels/whatsapp/$connectionId',path: '/channels/whatsapp/$connectionId',getParentRoute: () => SaasAppOrgOrganizationSlugRoute
          })





const AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,AuthLoginRoute: AuthLoginRoute,AuthResetPasswordRoute: AuthResetPasswordRoute,AuthSignupRoute: AuthSignupRoute,AuthVerifyRoute: AuthVerifyRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)




const MarketingRouteChildren = {
  MarketingAgenticCommerceRoute: MarketingAgenticCommerceRoute,MarketingAiAgentForEcommerceRoute: MarketingAiAgentForEcommerceRoute,MarketingArabicChatbotForEcommerceRoute: MarketingArabicChatbotForEcommerceRoute,MarketingBestAiShoppingAssistantsRoute: MarketingBestAiShoppingAssistantsRoute,MarketingDemoRoute: MarketingDemoRoute,MarketingHowItWorksRoute: MarketingHowItWorksRoute,MarketingIntegrationsRoute: MarketingIntegrationsRoute,MarketingLebanonRoute: MarketingLebanonRoute,MarketingQuickCommerceRoute: MarketingQuickCommerceRoute,MarketingSaudiArabiaRoute: MarketingSaudiArabiaRoute,MarketingSecurityRoute: MarketingSecurityRoute,MarketingShoppableRecipesRoute: MarketingShoppableRecipesRoute,MarketingSupermarketsRoute: MarketingSupermarketsRoute,MarketingUaeRoute: MarketingUaeRoute,MarketingIndexRoute: MarketingIndexRoute,MarketingChannelsInAppRoute: MarketingChannelsInAppRoute,MarketingChannelsVoiceRoute: MarketingChannelsVoiceRoute,MarketingChannelsWhatsappRoute: MarketingChannelsWhatsappRoute,MarketingCompareVendorRoute: MarketingCompareVendorRoute,MarketingSecurityPdplRoute: MarketingSecurityPdplRoute,MarketingCompareIndexRoute: MarketingCompareIndexRoute
}

const MarketingRouteWithChildren = MarketingRoute._addFileChildren(MarketingRouteChildren)




const SaasAppAccountSettingsRouteChildren = {
  SaasAppAccountSettingsDangerZoneRoute: SaasAppAccountSettingsDangerZoneRoute,SaasAppAccountSettingsGeneralRoute: SaasAppAccountSettingsGeneralRoute,SaasAppAccountSettingsNotificationsRoute: SaasAppAccountSettingsNotificationsRoute,SaasAppAccountSettingsPrivacyRoute: SaasAppAccountSettingsPrivacyRoute,SaasAppAccountSettingsSecurityRoute: SaasAppAccountSettingsSecurityRoute,SaasAppAccountSettingsIndexRoute: SaasAppAccountSettingsIndexRoute
}

const SaasAppAccountSettingsRouteWithChildren = SaasAppAccountSettingsRoute._addFileChildren(SaasAppAccountSettingsRouteChildren)



const SaasAppAccountRouteChildren = {
  SaasAppAccountPartnerRoute: SaasAppAccountPartnerRoute,SaasAppAccountPlatformRoute: SaasAppAccountPlatformRoute,SaasAppAccountSettingsRoute: SaasAppAccountSettingsRouteWithChildren,SaasAppAccountIndexRoute: SaasAppAccountIndexRoute
}

const SaasAppAccountRouteWithChildren = SaasAppAccountRoute._addFileChildren(SaasAppAccountRouteChildren)




const SaasAppOrgOrganizationSlugSettingsRouteChildren = {
  SaasAppOrgOrganizationSlugSettingsApiKeysRoute: SaasAppOrgOrganizationSlugSettingsApiKeysRoute,SaasAppOrgOrganizationSlugSettingsAuditRoute: SaasAppOrgOrganizationSlugSettingsAuditRoute,SaasAppOrgOrganizationSlugSettingsDangerZoneRoute: SaasAppOrgOrganizationSlugSettingsDangerZoneRoute,SaasAppOrgOrganizationSlugSettingsDomainsRoute: SaasAppOrgOrganizationSlugSettingsDomainsRoute,SaasAppOrgOrganizationSlugSettingsGeneralRoute: SaasAppOrgOrganizationSlugSettingsGeneralRoute,SaasAppOrgOrganizationSlugSettingsMembersRoute: SaasAppOrgOrganizationSlugSettingsMembersRoute,SaasAppOrgOrganizationSlugSettingsPrivacyDataRoute: SaasAppOrgOrganizationSlugSettingsPrivacyDataRoute,SaasAppOrgOrganizationSlugSettingsRolesRoute: SaasAppOrgOrganizationSlugSettingsRolesRoute,SaasAppOrgOrganizationSlugSettingsUsageRoute: SaasAppOrgOrganizationSlugSettingsUsageRoute,SaasAppOrgOrganizationSlugSettingsIndexRoute: SaasAppOrgOrganizationSlugSettingsIndexRoute
}

const SaasAppOrgOrganizationSlugSettingsRouteWithChildren = SaasAppOrgOrganizationSlugSettingsRoute._addFileChildren(SaasAppOrgOrganizationSlugSettingsRouteChildren)



const SaasAppOrgOrganizationSlugRouteChildren = {
  SaasAppOrgOrganizationSlugSplatRoute: SaasAppOrgOrganizationSlugSplatRoute,SaasAppOrgOrganizationSlugAgentRoute: SaasAppOrgOrganizationSlugAgentRoute,SaasAppOrgOrganizationSlugBranchesRoute: SaasAppOrgOrganizationSlugBranchesRoute,SaasAppOrgOrganizationSlugCatalogRoute: SaasAppOrgOrganizationSlugCatalogRoute,SaasAppOrgOrganizationSlugConversationsRoute: SaasAppOrgOrganizationSlugConversationsRoute,SaasAppOrgOrganizationSlugConversionsRoute: SaasAppOrgOrganizationSlugConversionsRoute,SaasAppOrgOrganizationSlugEvalsRoute: SaasAppOrgOrganizationSlugEvalsRoute,SaasAppOrgOrganizationSlugInstallRoute: SaasAppOrgOrganizationSlugInstallRoute,SaasAppOrgOrganizationSlugIntegrationsRoute: SaasAppOrgOrganizationSlugIntegrationsRoute,SaasAppOrgOrganizationSlugLogsRoute: SaasAppOrgOrganizationSlugLogsRoute,SaasAppOrgOrganizationSlugSearchRoute: SaasAppOrgOrganizationSlugSearchRoute,SaasAppOrgOrganizationSlugSettingsRoute: SaasAppOrgOrganizationSlugSettingsRouteWithChildren,SaasAppOrgOrganizationSlugIndexRoute: SaasAppOrgOrganizationSlugIndexRoute,SaasAppOrgOrganizationSlugCallsCallIdRoute: SaasAppOrgOrganizationSlugCallsCallIdRoute,SaasAppOrgOrganizationSlugChannelsTemplatesRoute: SaasAppOrgOrganizationSlugChannelsTemplatesRoute,SaasAppOrgOrganizationSlugCustomersCustomerIdRoute: SaasAppOrgOrganizationSlugCustomersCustomerIdRoute,SaasAppOrgOrganizationSlugOrdersOrderIdRoute: SaasAppOrgOrganizationSlugOrdersOrderIdRoute,SaasAppOrgOrganizationSlugOrdersSetupRoute: SaasAppOrgOrganizationSlugOrdersSetupRoute,SaasAppOrgOrganizationSlugSourcesSourceIdRoute: SaasAppOrgOrganizationSlugSourcesSourceIdRoute,SaasAppOrgOrganizationSlugCallsIndexRoute: SaasAppOrgOrganizationSlugCallsIndexRoute,SaasAppOrgOrganizationSlugChannelsIndexRoute: SaasAppOrgOrganizationSlugChannelsIndexRoute,SaasAppOrgOrganizationSlugCustomersIndexRoute: SaasAppOrgOrganizationSlugCustomersIndexRoute,SaasAppOrgOrganizationSlugOrdersIndexRoute: SaasAppOrgOrganizationSlugOrdersIndexRoute,SaasAppOrgOrganizationSlugSourcesIndexRoute: SaasAppOrgOrganizationSlugSourcesIndexRoute,SaasAppOrgOrganizationSlugChannelsWhatsappConnectionIdRoute: SaasAppOrgOrganizationSlugChannelsWhatsappConnectionIdRoute
}

const SaasAppOrgOrganizationSlugRouteWithChildren = SaasAppOrgOrganizationSlugRoute._addFileChildren(SaasAppOrgOrganizationSlugRouteChildren)



const SaasAppRouteChildren = {
  SaasAppAccountRoute: SaasAppAccountRouteWithChildren,SaasAppOrgOrganizationSlugRoute: SaasAppOrgOrganizationSlugRouteWithChildren
}

const SaasAppRouteWithChildren = SaasAppRoute._addFileChildren(SaasAppRouteChildren)



const SaasRouteChildren = {
  SaasAppRoute: SaasAppRouteWithChildren,SaasNewOrganizationRoute: SaasNewOrganizationRoute,SaasOrganizationInvitationInvitationIdRoute: SaasOrganizationInvitationInvitationIdRoute
}

const SaasRouteWithChildren = SaasRoute._addFileChildren(SaasRouteChildren)

const rootRouteChildren = {
  SplatRoute: SplatRoute,AuthRoute: AuthRouteWithChildren,MarketingRoute: MarketingRouteWithChildren,SaasRoute: SaasRouteWithChildren,EmbedTestRoute: EmbedTestRoute,COrgSlugRoute: COrgSlugRoute,LegalSlugRoute: LegalSlugRoute,COrgSlugCheckoutCheckoutIdRoute: COrgSlugCheckoutCheckoutIdRoute,COrgSlugOrdersTokenRoute: COrgSlugOrdersTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)